import styles from './VarItemCorrect.module.css';
import { motion } from 'framer-motion';

const VarItemCorrect = ({
  item,
  i,
  answerFontSize,
  varNumFontSize,
  isQuestionImg,
}) => {
  return (
    <div
      className={styles.varCorrect}
      style={{ minHeight: isQuestionImg ? 'none' : '20rem' }}>
      <motion.div
        initial={{
          boxShadow: '-0.2rem -0.15rem #3796eb',
        }}
        animate={{
          boxShadow: '-0.2rem -0.15rem #ff8c39',
        }}
        transition={{
          duration: 1,
          delay: 1,
        }}
        className={styles.varNumberCorrect}
        style={{
          fontSize: `${varNumFontSize}rem`,
          height: `${1.17 * varNumFontSize}rem`,
          minWidth: `${1.17 * varNumFontSize}rem`,
        }}>
        {i + 1}
      </motion.div>
      <motion.div
        initial={{ color: '#fff' }}
        animate={{ color: '#161616' }}
        transition={{
          duration: 1,
          delay: 1,
        }}
        className={styles.varTitleCorrect}
        style={{
          fontSize: `${answerFontSize}rem`,
          maxWidth: isQuestionImg ? '78rem' : '47.92rem',
        }}>
        {item.comment}
        <motion.div
          initial={{ left: '0rem' }}
          animate={{ left: '-100%' }}
          transition={{
            duration: 1,
            delay: 1,
          }}
          className={styles.varBgCorect}>
          <div className={styles.varBgCorect1}></div>
          <div className={styles.varBgCorect2}></div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default VarItemCorrect;
